import React, { useEffect, useState } from "react";
import TkButton from "../../atoms/TkButton";
import TkSalaryAdjustmentAmountDialog from "../TkSalaryAdjustmentAmountDialog";
import { ITkSalaryAdjustmentAmount } from "../../../type/componentsType/TkSalaryAdjustmentAmount";
import { Box } from "@mui/material";
import "./_style.scss";

/**
 * TkSalaryAdjustmentAmountコンポーネント
 * @param {ITkSalaryAdjustmentAmount} props - コンポーネントのプロパティ
 * @param {Function} props.onConfirm - 確認コールバック関数
 * @param {...any} props.rest - その他のプロパティ
 * @returns {React.FC<ITkSalaryAdjustmentAmount>} TkSalaryAdjustmentAmountコンポーネント
 */
const TkSalaryAdjustmentAmount: React.FC<ITkSalaryAdjustmentAmount> = (
  props
) => {
  const { onConfirm, selList, selectedList, ...rest } = props;

  const [open, setOpen] = useState(false);
  const [showText, setShowText] = useState("");
  const [selListInCom, setSelListInCom] = useState<any>([]);

  useEffect(() => {
    if (selectedList) {
      setSelListInCom(selectedList);
      setShowText(() => selectedList.map((item: any) => item.label).join("、"));
    }
  }, [selectedList]);

  // 選択の確認ハンドラー
  const handleComfirm = (e: any) => {
    setSelListInCom(e);
    setShowText(() => e.map((item: any) => item.label).join("、"));
    onConfirm && onConfirm(e);
    setOpen(false);
  };

  return (
    <Box className="tkSalaryAdjustmentAmount">
      <Box className="buttonBox">
        <TkButton onClick={() => setOpen(true)}>選択</TkButton>
        {showText && <Box>{showText}</Box>}
      </Box>

      <TkSalaryAdjustmentAmountDialog
        {...rest}
        selList={selList}
        open={open}
        selectedList={selListInCom}
        onClose={() => setOpen(false)}
        onConfirm={handleComfirm}
      />
    </Box>
  );
};

export default TkSalaryAdjustmentAmount;
